import { createFileRoute, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPasswordScreen } from '@/features/auth/routes/reset-password-screen'

const searchSchema = z.object({ token: z.string().optional() })

export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordRoute,
})

function ResetPasswordRoute() {
  const { token } = useSearch({ from: '/reset-password' })
  return <ResetPasswordScreen token={token ?? null} />
}
